export default {"src":"/_next/static/media/nav-icons.c3fa7dd1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};